import zElForm from './src/main.vue';
zElForm.install = (Vue) => {
	Vue.component(zElForm.name, zElForm);
};
export default zElForm;
